import { protocolsQuery } from '@/api/protocols/protocolQueries';
import SquigglyLine14Icon from '@/assets/icons/squiggly-lines/squiggly-line-14.svg?react';
import SquigglyLine7Icon from '@/assets/icons/squiggly-lines/squiggly-line-7.svg?react';
import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from '@/components/common/Carousel';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { Spinner } from '@/components/common/Spinner';
import { FormulaCard } from '@/components/home/FormulaCard';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useQuery } from '@tanstack/react-query';

export function FormulasSection() {
  const { isDesktop } = useBreakpoint();
  const { data: protocols, isLoading } = useQuery(protocolsQuery());

  return (
    <Section containerClassName="pb-2.5 lg:pb-1 pt-0 lg:pt-22.5">
      <Heading
        as="h2"
        className="text-secondary mb-12.25 lg:mb-21.75"
        underlinedText="formulas"
        underline={
          isDesktop ? (
            <SquigglyLine14Icon className="-bottom-5 -left-5.5" />
          ) : (
            <SquigglyLine7Icon className="-bottom-1.5 -left-0.5" />
          )
        }
      >
        Our protocol based formulas
      </Heading>

      {isLoading ? (
        <div className="flex min-h-37 items-center justify-center lg:min-h-47">
          <Spinner className="size-8" />
        </div>
      ) : protocols?.data.length === 0 ? null : (
        <Carousel
          opts={{
            align: isDesktop ? 'center' : 'start',
          }}
          className="-mx-4 lg:left-[50%] lg:ml-[-50vw] lg:w-screen"
        >
          <CarouselContent className="ml-0 lg:pl-0">
            {protocols?.data.map((protocol, index) => (
              <CarouselItem
                key={protocol.id}
                className="w-auto min-w-65.5 shrink-0 basis-auto pl-4 lg:min-w-101.75 lg:pl-5"
              >
                <FormulaCard protocol={protocol} index={index} />
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselDots count={protocols?.data.length ?? 0} />
        </Carousel>
      )}
    </Section>
  );
}
